export const PHONE_DISPLAY = "(732) 446-7211";
export const PHONE_HREF = "tel:+17324467211";
export const EMAIL = "Nadiasfamilysalon@yahoo.com";
export const BOOKING_URL = "https://nadiassalon.mysalononline.com/Booking/?sid=0";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=14+Wilson+Avenue+Suite+3+Englishtown+NJ+07726";
export const GOOGLE_REVIEWS_URL = "https://share.google/5fpbwkA6Ptwz55eRb";

export const navigation = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about-us/" },
  { label: "Services", path: "/services/" },
  { label: "Weddings", path: "/wedding/" },
  { label: "Makeup", path: "/make-up/" },
  { label: "Specials", path: "/specials/" },
  { label: "Staff", path: "/staff/" },
  { label: "Gallery", path: "/photo-gallery/" },
  { label: "Contact", path: "/contact-us/" },
] as const;

export type ServiceItem = { name: string; price: string };
export type ServiceGroup = { title: string; note?: string; items: ServiceItem[] };

// Prices follow the salon's DaySmart booking system (DC-9678). Rows marked
// "not in booking system" come from the salon's own price list and have no
// online-booking equivalent.
export const serviceGroups: ServiceGroup[] = [
  {
    title: "Women’s hair",
    note: "All luxury services include a conditioning treatment.",
    items: [
      { name: "Bang trim", price: "$7 & up" },
      { name: "Senior mist and cut", price: "$30 & up" }, // not in booking system
      { name: "Senior wash and style", price: "$35 & up" },
      { name: "Senior wash and cut", price: "$40 & up" }, // not in booking system
      { name: "Wash and style", price: "$40 & up" },
      { name: "Wash and cut", price: "$52 & up" },
      { name: "Senior wash, cut and style", price: "$55 & up" },
      { name: "Luxury wash and style", price: "$60 & up" }, // not in booking system
      { name: "Wash, cut and style", price: "$70 & up" },
      { name: "Senior perm", price: "$76 & up" }, // not in booking system
      { name: "Perm", price: "$78 & up" }, // not in booking system
      { name: "Luxury wash, cut and style", price: "$80 & up" }, // not in booking system
    ],
  },
  {
    title: "Men’s hair",
    items: [
      { name: "Complimentary neck trim", price: "Free" },
      { name: "Beard trim only", price: "$12 & up" },
      { name: "Neck trim", price: "$12 & up" },
      { name: "Senior men’s cut (65 and up)", price: "$21 & up" },
      { name: "Buzz cut", price: "$21 & up" },
      { name: "Men’s cut", price: "$32 & up" },
      { name: "Men’s cut and beard", price: "$37 & up" },
    ],
  },
  {
    title: "Children’s hair",
    note: "Cutting services for children age 11 and under.",
    items: [
      { name: "Mist and cut", price: "$28 & up" },
      { name: "Wash and cut", price: "$35 & up" }, // not in booking system
      { name: "Wash, cut and style", price: "$50 & up" },
    ],
  },
  {
    title: "Special occasion",
    items: [
      { name: "Bridal consultation", price: "Free" },
      { name: "Special occasion extension add-on", price: "$10 & up" },
      { name: "Down with curls", price: "$74 & up" },
      { name: "Special occasion hair style", price: "$100 & up" },
    ],
  },
  {
    title: "Hair color",
    note: "Please add a toner to any foil service.",
    items: [
      { name: "Clarifying treatment for BTS", price: "Free" },
      { name: "Eyebrow color only", price: "$12 & up" },
      { name: "Men’s beard color", price: "$25 & up" },
      { name: "Men’s single process", price: "$55 & up" },
      { name: "The Demi single process", price: "$70 & up" },
      { name: "Bleach retouch", price: "$74 & up" },
      { name: "PM Shines Kerabrilliance single process", price: "$76 & up" },
      { name: "Men’s highlight and cut", price: "$80 & up" },
      { name: "Single process color (touch-up)", price: "$80 & up" },
      { name: "Men’s color and cut", price: "$85 & up" },
      { name: "Partial head foil (¼ head)", price: "$90 & up" },
      { name: "Single process with PM tone (same time)", price: "$108 & up" },
      { name: "Half head foil", price: "$115 & up" },
      { name: "Partial custom lightening", price: "$115 & up" },
      { name: "Ombré", price: "$130 & up" },
      { name: "Full head foil", price: "$150 & up" },
      { name: "Custom lightening", price: "$185 & up" },
      { name: "Partial custom lightening with single process", price: "$185 & up" },
      { name: "Full head foil with single process", price: "$220 & up" },
      { name: "Custom lightening with single process", price: "$225 & up" },
    ],
  },
  {
    title: "Hair treatments",
    items: [
      { name: "KC Timeless color mask", price: "$10 & up" },
      { name: "Deep conditioning", price: "$25 & up" }, // not in booking system
      { name: "PM relaxer", price: "$75 & up" },
      { name: "Keratin Express", price: "$120 & up" },
      { name: "Keratin Personalized Blowout, curly", price: "$200 & up" },
      { name: "Keratin", price: "$255 & up" },
      { name: "Keratin Max", price: "$260 & up" },
      { name: "Keratin Personalized Blowout, straight", price: "$275 & up" },
    ],
  },
  {
    title: "Extensions",
    items: [
      { name: "Clip-on extension application", price: "$20 & up" },
      { name: "Re-tape extensions", price: "$25 & up" },
      { name: "Single process extensions, one pack", price: "$30 & up" },
      { name: "Tape-in extension service", price: "$125 & up" },
    ],
  },
  {
    title: "Add-on services",
    items: [
      { name: "10-minute scalp massage", price: "$15 & up" },
      { name: "Silky smooth anti-frizz and humidity treatment", price: "$20 & up" },
      { name: "Tinsel, 5 for $20", price: "$20" },
      { name: "Toner", price: "$30 & up" },
    ],
  },
  {
    title: "Makeup",
    items: [
      { name: "Lash application (your own lashes)", price: "$5 & up" },
      { name: "Lashes", price: "$15 & up" },
      { name: "Makeup consultation", price: "$35 & up" },
      { name: "Eye makeup only", price: "$40 & up" },
      { name: "Eye makeup with lashes", price: "$50 & up" },
      { name: "Full-face makeup", price: "$70 & up" },
      { name: "Full-face makeup with lashes", price: "$81 & up" },
    ],
  },
  {
    title: "Waxing",
    items: [
      { name: "Chin", price: "$10 & up" },
      { name: "Lip", price: "$10 & up" },
      { name: "Sideburns", price: "$10 & up" }, // not in booking system
      { name: "Brows", price: "$15 & up" },
      { name: "Lower back", price: "$20 & up" },
      { name: "Underarms", price: "$25 & up" },
      { name: "Half arm", price: "$30 & up" },
      { name: "Upper back", price: "$30 & up" },
      { name: "Lower leg", price: "$35 & up" },
      { name: "Full arm", price: "$38 & up" },
      { name: "Full face", price: "$40 & up" },
      { name: "Upper leg", price: "$45 & up" },
      { name: "Full back", price: "$65 & up" },
      { name: "Full leg", price: "$75 & up" },
    ],
  },
  {
    title: "Threading",
    items: [
      { name: "Intense RX serum treatment", price: "$5 & up" },
      { name: "Lip", price: "$5 & up" },
      { name: "Brows", price: "$12 & up" },
      { name: "Full face", price: "$30 & up" },
    ],
  },
  {
    title: "Skin care",
    items: [
      { name: "Express eye treatment", price: "$15 & up" },
      { name: "Eye treatment", price: "$15 & up" },
      { name: "30-minute eye treatment", price: "$30 & up" },
    ],
  },
  {
    title: "Hair donation",
    items: [
      { name: "Cut-A-Thon", price: "Free" },
      { name: "Locks of Love donation, wash and cut", price: "Free" },
    ],
  },
];

export const reviews = [
  {
    quote: "Great atmosphere and service.",
    name: "Evie B",
    rating: 5,
  },
  {
    quote: "Great staff great experience from beginning to end.",
    name: "Nané Sirekan",
    rating: 5,
  },
  {
    quote: "I am always blown away from the work done by Melissa.",
    name: "Brianna Sozzi",
    rating: 5,
  },
] as const;

export const staff = [
  {
    name: "Joseph Jackson",
    image: "/images/staff/joseph.jpg",
    alt: "Joseph Jackson of Nadia's Salon",
    about: "Coming from a 20-year background in skincare and esthetician work, I began barbering in 2015, discovering both a talent and a passion for creating myriad looks from conservative to progressive styles.",
    certifications: "Paul Mitchell Men's Cuts, Paul Mitchell Advanced Color, Reuzel Men's Barbering Techniques and Designs, Wahl Men's Designer Cuts, Keratin Treatments and Keratin Color.",
    specialties: "Barbering, Men’s and Women's Color.",
  },
  {
    name: "Erika",
    image: "/images/staff/erika-2026-09.jpg",
    alt: "Erika of Nadia's Salon",
    about: "I could not picture myself not being in this industry. I LOVE what I do! Working with people in the most creative atmosphere is such a great experience on a daily basis. The feeling of making people look and feel great is like no other. Seeing that smile and their face light up makes me realize why being a stylist is so great. I have been at Nadia's Salon for over 20 years, and it has really allowed me to grow and helped me to hone my craft. True beauty comes from within and having the ability to allow people to show that on the outside is the real joy of this job!",
    certifications: "Keratin by Coppala, Paul Mitchell Color, Paul Mitchell Foundations of Cutting, Paul Mitchell Advanced Color, Paul Mitchell Advanced Cutting, Paul Mitchell Hair Camp (2006, 2010), Big Sexy Hair Advanced Cutting, Keratin Complex Certified.",
    specialties: "Keratin, Color, Cut, Special Occasion Styles",
  },
  {
    name: "Kristin Seely",
    image: "/images/staff/kristin.jpg",
    alt: "Kristin Seely of Nadia's Salon",
    about: "I have been in the industry since 2014. With a talent for color and custom lightening applications, I enjoy assisting my clients in achieving their desired look. I love creative styles, fashion colors as well as subtle touchup processes and always look forward to the big reveal at the end of a blow out.",
    certifications: "Keratin Complex Certified, KCMAX Straightening and Smoothing Treatment Certified, Paul Mitchell Advanced Coloring, Paul Mitchell Blowout Boot Camp, Reuzel Men's Advanced Styling",
    specialties: "Keratin, Color, Special Occasions, Dry Styling, Men's Cuts, Shampoo Bowl Treatments",
  },
  {
    name: "Brianna",
    image: "/images/staff/brianna.jpg",
    alt: "Brianna of Nadia's Salon",
    about: "I'm Brianna, a hairstylist here at Nadia's Salon with 2 years of experience. I mostly specialize in haircuts, blowouts, and blonding services. I also have a certification in all keratin treatments by Keratin Complex.",
  },
  {
    name: "Layla",
    image: "/images/staff/layla.jpg",
    alt: "Layla of Nadia's Salon",
    about: "I’m a hairstylist with one year of hands-on experience, but a lifelong passion for hair. I’ve always been drawn to the creativity and personal expression that comes with styling. Every style I create is an opportunity to help someone feel confident and uniquely themselves. I’m excited to keep learning, growing, and bringing new ideas to life through my work. Each appointment is a chance to turn a vision into reality.",
    certifications: "Keratin Complex, LightStim LED, Prosper U program, Principal Based Design",
  },
] as const;

export const gallery = [
  { src: "/images/gallery/legacy-gallery-01.jpg", alt: "Finished curled ponytail from the salon portfolio" },
  { src: "/images/gallery/legacy-gallery-02.jpg", alt: "Stylist working on long curls in the salon" },
  { src: "/images/gallery/legacy-gallery-03.jpg", alt: "Intricate braided hairstyle in progress" },
  { src: "/images/gallery/legacy-gallery-04.jpg", alt: "Stylist trimming long dark hair" },
  { src: "/images/gallery/legacy-gallery-05.jpg", alt: "Stylist arranging a model's hair" },
  { src: "/images/gallery/legacy-gallery-06.jpg", alt: "Curling iron styling close-up" },
  { src: "/images/gallery/legacy-gallery-07.jpg", alt: "Stylist curling long dark hair" },
  { src: "/images/gallery/legacy-gallery-08.jpg", alt: "Finished long blonde curls from the back" },
  { src: "/images/gallery/legacy-gallery-09.jpg", alt: "Finished blonde curls from the side" },
  { src: "/images/gallery/legacy-gallery-10.jpg", alt: "Client with long blonde curls" },
  { src: "/images/gallery/legacy-gallery-11.jpg", alt: "Portrait of a client with finished blonde curls" },
  { src: "/images/gallery/legacy-gallery-12.jpg", alt: "Long auburn curls from the back" },
  { src: "/images/gallery/legacy-gallery-13.jpg", alt: "Long auburn curls from the side" },
  { src: "/images/gallery/legacy-gallery-14.jpg", alt: "Makeup artist applying eye makeup" },
  { src: "/images/gallery/legacy-gallery-15.jpg", alt: "Stylists preparing a model's hair and makeup" },
  { src: "/images/gallery/legacy-gallery-16.jpg", alt: "Stylist arranging a special-occasion updo" },
  { src: "/images/gallery/legacy-gallery-17.jpg", alt: "Soft blonde waves in side profile" },
  { src: "/images/gallery/legacy-gallery-18.jpg", alt: "Blonde formal updo from the side" },
  { src: "/images/gallery/legacy-gallery-19.jpg", alt: "Braided blonde updo from the back" },
  { src: "/images/gallery/legacy-gallery-20.jpg", alt: "Long curled blonde half-up style" },
  { src: "/images/gallery/legacy-gallery-21.jpg", alt: "Intricate dark updo from the back" },
  { src: "/images/gallery/legacy-gallery-22.jpg", alt: "Blonde model with styled curls" },
  { src: "/images/gallery/legacy-gallery-23.jpg", alt: "Brunette model with side-swept curls" },
  { src: "/images/gallery/legacy-gallery-24.jpg", alt: "Stylist working with a client in the salon" },
  { src: "/images/gallery/legacy-gallery-25.jpg", alt: "Makeup artist applying eye makeup to a client" },
  { src: "/images/gallery/legacy-gallery-26.jpg", alt: "Finished golden curls from the back" },
  { src: "/images/gallery/legacy-gallery-27.jpg", alt: "Curled brunette half-up style" },
  { src: "/images/gallery/legacy-gallery-28.jpg", alt: "Stylist curling blonde hair" },
  { src: "/images/gallery/legacy-gallery-29.jpg", alt: "Stylist creating long blonde curls" },
  { src: "/images/gallery/legacy-gallery-30.jpg", alt: "Long dark curls from the side" },
  { src: "/images/gallery/legacy-gallery-31.jpg", alt: "Stylist curling long hair" },
  { src: "/images/gallery/legacy-gallery-32.jpg", alt: "Curled blonde updo detail" },
  { src: "/images/gallery/legacy-gallery-33.jpg", alt: "Blonde curls in side profile" },
  { src: "/images/gallery/legacy-gallery-34.jpg", alt: "Dark braided updo from the back" },
  { src: "/images/gallery/legacy-gallery-35.jpg", alt: "Brunette curls in side profile" },
  { src: "/images/gallery/legacy-gallery-36.jpg", alt: "Polished blonde updo from the back" },
  { src: "/images/gallery/legacy-gallery-37.jpg", alt: "Braided blonde updo from the back" },
  { src: "/images/gallery/legacy-gallery-38.jpg", alt: "Textured auburn half-up hairstyle" },
  { src: "/images/gallery/legacy-gallery-39.jpg", alt: "Long auburn curls from the back" },
  { src: "/images/gallery/legacy-gallery-40.jpg", alt: "Stylist at work in the salon" },
  { src: "/images/gallery/legacy-gallery-41.jpg", alt: "Stylist sectioning blonde hair" },
  { src: "/images/gallery/legacy-gallery-42.jpg", alt: "Stylist curling long dark hair" },
  { src: "/images/gallery/legacy-gallery-43.jpg", alt: "Curl styling in progress" },
  { src: "/images/gallery/legacy-gallery-44.jpg", alt: "Makeup application close-up" },
  { src: "/images/gallery/legacy-gallery-45.jpg", alt: "Eye makeup application close-up" },
  { src: "/images/gallery/legacy-gallery-46.jpg", alt: "Braided hairstyle in progress" },
  { src: "/images/gallery/legacy-gallery-47.jpg", alt: "Curling blonde hair close-up" },
  { src: "/images/gallery/legacy-gallery-48.jpg", alt: "Salon styling team at work" },
  { src: "/images/gallery/legacy-gallery-49.jpg", alt: "Makeup artist applying makeup to a client" },
  { src: "/images/gallery/legacy-gallery-50.jpg", alt: "Curling iron close-up" },
  { src: "/images/gallery/legacy-gallery-51.jpg", alt: "Curling a section of blonde hair" },
  { src: "/images/gallery/legacy-gallery-52.jpg", alt: "Stylist curling long dark hair" },
  { src: "/images/gallery/legacy-gallery-53.jpg", alt: "Curling tools beside blonde hair" },
  { src: "/images/gallery/legacy-gallery-54.jpg", alt: "Curling iron detail on long blonde hair" },
  { src: "/images/gallery/legacy-gallery-55.jpg", alt: "Finished long dark curls" },
  { src: "/images/gallery/legacy-gallery-56.jpg", alt: "Braided special-occasion hairstyle in side profile" },
] as const;

export const pageMetadata: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Nadia's Salon | Hair, color & wedding services in Englishtown, NJ",
    description: "Look and feel your best with attentive haircuts, color, treatments, makeup, waxing, and wedding services at Nadia's Salon.",
  },
  "/about-us/": {
    title: "About Nadia's Salon | Family hair salon in Englishtown, NJ",
    description: "Learn about Nadia's Salon, a family hair salon in Englishtown, New Jersey offering cuts, color, treatments, makeup, waxing, and wedding services.",
  },
  "/services/": {
    title: "Hair, color, treatment & waxing services | Nadia's Salon",
    description: "Explore Nadia's Salon services and starting prices for women, men, children, color, keratin treatments, and facial waxing.",
  },
  "/wedding/": {
    title: "Wedding hair & makeup in Englishtown, NJ | Nadia's Salon",
    description: "Plan wedding hair, makeup, and bridal-party beauty at the salon or on location with Nadia's special-event team.",
  },
  "/make-up/": {
    title: "Professional makeup services | Nadia's Salon",
    description: "Get event-ready with full-face, eye and lip, bridal, and all-occasion makeup services from Nadia's Salon.",
  },
  "/specials/": {
    title: "Salon specials & personalized keratin blowouts | Nadia's Salon",
    description: "Learn about Nadia's customizable same-day Personalized Blowout keratin treatment and current salon offer.",
  },
  "/staff/": {
    title: "Staff | Nadia's Salon in Englishtown, NJ",
    description: "Meet the Nadia's Salon staff and learn about their backgrounds, continuing education, and specialties.",
  },
  "/photo-gallery/": {
    title: "Hair & special-event gallery | Nadia's Salon",
    description: "See hair color, curls, braids, updos, and special-event styling from Nadia's Salon's portfolio.",
  },
  "/contact-us/": {
    title: "Contact & directions | Nadia's Salon in Englishtown, NJ",
    description: "Call, message, book, or get directions to Nadia's Salon at 14 Wilson Avenue, Suite 3, Englishtown, New Jersey.",
  },
};
